<template>
  <b-form-group
    label="Sayısal Değer 2"
    label-for="int_value_2"
  >
    <cleave
      id="int_value_2"
      v-model="dataItem.int_value_2"
      class="form-control"
      :raw="true"
      :options="options.limit"
      placeholder="Sayısal Değer 2"
    />
  </b-form-group>
</template>

<script>
import { localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'

export default {
  name: 'ParamsNumberValue2',
  components: {
    BFormGroup,
    Cleave,
  },
  data() {
    return {
      required,
      options: {
        limit: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['params/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
